var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper-appraise-report"},[_c('AppScrollbar',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"main-cont"},[_c('div',{staticClass:"upload-cont"},[_c('DataUnpackModule',{attrs:{"unpack-url":_vm.uploadUrl,"pre-handle-params":_vm.uploadParams,"inline":""}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }